import EditCreditVehiclesScreen from "./EditCreditVehiclesScreen";
import EditCreditVehiclesScreenContainer from "./EditCreditVehiclesScreenContainer";

export default {
  EditCreditVehiclesScreen,
  EditCreditVehiclesScreenContainer
};
